module.exports = __webpack_public_path__ + "static/shoe-layers-4-dfbbbdeff108bcc48893c297ff6f088c.png";